import script from "./InvoicePrint.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoicePrint.vue?vue&type=script&setup=true&lang=js"

import "./InvoicePrint.vue?vue&type=style&index=0&id=7876921b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7876921b"]])

export default __exports__